const getBackgroundColor = (colorScheme: string) => {
  if (colorScheme === 'warning') return 'warning.100'
  if (colorScheme === 'error') return 'error.100'
  if (colorScheme === 'success') return 'success.100'
  if (colorScheme === 'info') return 'primary.100'
  return 'bg'
}

export default {
  defaultProps: {
    variant: 'solid',
  },
  baseStyle: {
    px: 2,
    py: 1,
  },
  variants: {
    solid: ({ colorScheme }: Record<string, any>) => ({
      bg: getBackgroundColor(colorScheme),
      borderWidth: 0,
      borderRadius: 'sm',
    }),
  },
}
